import { useLanguageSettings } from "providers/LanguageSettingsProvider/LanguageSettingsProvider"

import { Box, Flex, Text, Center } from "@chakra-ui/react"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import Input from "components/UI/atoms/Input"
import Pagination from "components/UI/organisms/Table/Pagination"
import { KEYWORD_TYPES } from "providers/LanguageSettingsProvider/LanguageSettingsProviderConstants"
import { IContentKeyword } from "types/content"
import { useUI } from "providers/UIProvider"

import ContentTypesTable from "./ContentTypesTable"

export const LanguageSettingsContent = () =>{

    const { T } = useUI()

    const { 
        currentKeywordType, 
        keywordsQuery, 
        keywords, 
        handleKeywordsPaginationClick, 
        inputValues,
        handleKeywordInputChange,
        handleSubmit
    } = useLanguageSettings()

    const displayPagination = currentKeywordType !== KEYWORD_TYPES.TYPES
    
    const renderKeywords = (keywords: IContentKeyword[]) => keywords.map((keyword) => (
        <Flex key={keyword.key} alignItems="flex-end" justifyContent="space-between" mb="25px">
            <Flex w="48%" alignItems={"center"} justifyContent="center" gap={"20px"}>
                <Flex h="49px" borderRadius={"40px"} padding={"15px 20px"} width={"fit-content"} backgroundColor={"#E9F2FD"}  alignItems={"center"} justifyContent="center" >
                    <Text width={"fit-content"} fontSize={"16px"} color="black">{keyword.key}</Text>
                </Flex>
                <Box flexGrow={1} position="relative" height={"5px"} >
                    <Box  backgroundColor={"#E9F2FD"} height={"5px"} width={"auto"} />
                    <Box position={"absolute"} right="-5" top="-22">
                    <Icon  name="arrowRight" iconStyles={{ width: "50px", height: "50px", fill: "#E9F2FD" }}/>
                    </Box>
                </Box>
            </Flex>
            <Box w="50%">
                <Input
                    id={keyword.key}
                    styles={{
                        width: "100%",
                        height: "50px",
                    }}
                    name={keyword.key}
                    // @ts-ignore
                    value={inputValues[currentKeywordType.toLowerCase()][keyword.key]}
                    type="text"
                    onChange={handleKeywordInputChange}
                    label={T("language_settings.form.input.label")}
                />
            </Box>
        </Flex>
    )) 

    return (
        <Box>
            <Box w="100%" maxHeight="1200px" overflowY="auto">
                {currentKeywordType === KEYWORD_TYPES.MOBILE && inputValues.mobile && renderKeywords(keywords.data)}
                {currentKeywordType === KEYWORD_TYPES.ADMIN && inputValues.admin && renderKeywords(keywords.data)}
                {currentKeywordType === KEYWORD_TYPES.TYPES && <ContentTypesTable />}
            </Box>
            {keywords.data.length > 0 && displayPagination && (
                <Pagination
                    total={keywords.itemCount}
                    perPage={keywordsQuery.pageSize}
                    currentPage={keywordsQuery.pageIndex}
                    onClick={handleKeywordsPaginationClick}
                />
            )}
            {keywords.data.length === 0 && (
                <Center>{T("general.no_results")}</Center>
            )}
            <Flex alignItems={"center"} mb={"28px"} justifyContent="center" mt={"53px"}>
                <Button 
                    text={T("actions.save")} 
                    onClick={handleSubmit} 
                    variant="success" 
                    styles={{ width: "190px", height: "80px", fontSize: "18px" }}
                    leftIcon={
                    <Icon
                        name="confirm"
                        iconStyles={{
                        width: "34px",
                        height: "34px",
                        fill: "white",
                        }}
                    />
                    }
                />
            </Flex >
        </Box> 
    )
}

export default LanguageSettingsContent